

















import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { storeModuleName } from '@/views/App/Profile/store'
import { mapGetters } from 'vuex'
import { CatalogItem } from 'src/requests/mainApi/models'
import UiButton from '@/components/ui/UiButton.vue'

interface Data {}

interface Methods {}

interface Computed {
  myFlats: CatalogItem[]
}

interface Props {
  flat: CatalogItem
}

export default Vue.extend({
  name: 'NewlyBoughtFlatCard',
  components: {
    UiButton
  },
  props: {
    flat: {
      type: Object,
      required: true
    }
  },
  computed: {
    getFlatDescription () {
      if (this.flat.studio) {
        return this.$t('app.profile.newlyBoughtFlat.flatDescriptionStudio', this.flat)
      }
      return this.$t('app.profile.newlyBoughtFlat.flatDescription', this.flat)
    },
    ...mapGetters(storeModuleName, ['myFlats'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
